module.exports = __webpack_public_path__ + "media/videos/home/hero-h264-57124edcf4db68f7a300f6c78bbbbc6a.mp4";